import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "approved-setting" }
const _hoisted_2 = { class: "approved-setting__header flex flex-col justify-end items-end mb-3" }
const _hoisted_3 = { class: "flex justify-center" }
const _hoisted_4 = { class: "flex justify-center" }
const _hoisted_5 = { class: "items-center" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "items-center" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "flex items-center justify-center" }
const _hoisted_10 = { class: "icon-tooltip cursor-pointer" }
const _hoisted_11 = { class: "tooltiptext" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-edit-square text-2xl hover:text-blue-600 cursor-pointer text-gray-333" }, null, -1)
const _hoisted_13 = { class: "mt-8 flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GradationButton = _resolveComponent("GradationButton")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Table = _resolveComponent("Table")
  const _component_Button = _resolveComponent("Button")
  const _component_MainLayoutContentMedium = _resolveComponent("MainLayoutContentMedium")

  return (_openBlock(), _createBlock(_component_MainLayoutContentMedium, null, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_GradationButton, {
            class: "approved-setting__button mb-3",
            onClick: _ctx.redirectApplicationFlowSetting
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('approvedSetting.btnBasicFlowSetting')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_GradationButton, {
            class: "approved-setting__button",
            disabled: _ctx.isDisabledBtnApply,
            onClick: _ctx.handleApplyList
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('approvedSetting.btnBasicFlowApplication')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        (_openBlock(), _createBlock("div", {
          class: "approved-setting__main",
          key: _ctx.keyEl
        }, [
          _createVNode(_component_Table, {
            data: _ctx.unitList,
            headers: _ctx.approvedSettingHeaders,
            showPagination: true,
            recordTotal: _ctx.pagination.total,
            itemsPerPages: _ctx.pagination.per_page,
            currentPage: _ctx.params.page,
            "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => (_ctx.params.page = $event)),
            onOnChangePage: _ctx.onChangePage
          }, {
            unit_code: _withCtx(({ item }) => [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", null, _toDisplayString(item.unit_code), 1)
              ])
            ]),
            unit_name: _withCtx(({ item }) => [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", null, _toDisplayString(item.unit_name), 1)
              ])
            ]),
            "header-checkbox": _withCtx(({ item }) => [
              _createVNode("div", _hoisted_5, [
                _createVNode("span", _hoisted_6, _toDisplayString(item.text), 1),
                _createVNode(_component_Checkbox, {
                  classes: "justify-center",
                  onChange: _ctx.onSelectedAll,
                  modelValue: _ctx.isCheckAll,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isCheckAll = $event)),
                  disabled: _ctx.approvedSelectedDefault.length === _ctx.unitList.length
                }, null, 8, ["onChange", "modelValue", "disabled"])
              ])
            ]),
            checkbox: _withCtx(({ item }) => [
              _createVNode("div", _hoisted_7, [
                _createVNode("span", _hoisted_8, _toDisplayString(item.text), 1),
                _createVNode(_component_Checkbox, {
                  classes: "justify-center",
                  value: item,
                  modelValue: _ctx.approvedSelected,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.approvedSelected = $event)),
                  disabled: _ctx.approvedSelectedDefault.includes(item)
                }, null, 8, ["value", "modelValue", "disabled"])
              ])
            ]),
            copy: _withCtx(({ item }) => [
              _createVNode("div", _hoisted_9, [
                _createVNode("span", {
                  class: "cursor-pointer",
                  onClick: ($event: any) => (_ctx.redirectApplicationFlowPersonal(item))
                }, [
                  _createVNode("div", _hoisted_10, [
                    _createVNode("span", _hoisted_11, _toDisplayString(_ctx.t('actionEdit')), 1),
                    _hoisted_12
                  ])
                ], 8, ["onClick"])
              ])
            ]),
            _: 1
          }, 8, ["data", "headers", "recordTotal", "itemsPerPages", "currentPage", "onOnChangePage"])
        ])),
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_Button, { class: "btn-outline-blue w-58 h-12 mb-6" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('importTheFile')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Button, { class: "btn-outline-blue w-58 h-12 mb-6 ml-6" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('exportTheFile')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}